const $window = $(window);
let windowWidth = $window.width();
var _isTest = false;

// メディアクエリ
let mql = window.matchMedia('screen and (max-width: 1024px)');

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
// import {toggleHeader} from "../include/module";
// toggleHeader();

// pageTop
import {pageTop} from "../include/module";
pageTop();

// showMovie
import {showMovie} from "../include/module";
showMovie();

//anchorLink
// import {anchorLink} from "../include/module";
// anchorLink();


$(window).on('load' , function() {

  setTimeout(function(){$('.js-loadAnimation').addClass("is-animated");},100);
  scrollIndexAnime();

});



// ------------------------------------------------------------------------
// scrollIndexAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollIndexAnime = () => {

  const controller = new ScrollMagic.Controller();
  // const targets = document.querySelectorAll(".js-scrollAnimation");
  // const targetsArray = Array.prototype.slice.call(targets); //Array
  // targetsArray.forEach(target => {
  // //シーンを作成
  // const scene = new ScrollMagic.Scene({
  //     triggerElement: target,
  //     triggerHook: .8
  //   })
  //   .setClassToggle(target, "is-animated")
  //   .addTo(controller);
  // });

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-News',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

  //　スクロールで発火系
  const targets = document.querySelectorAll(".js-scrollAnimation");
  const targetsArray = Array.prototype.slice.call(targets); //Array
  targetsArray.forEach(target => {
    //シーンを作成
    const scene3 = new ScrollMagic.Scene({
        triggerElement: target,
        triggerHook: .8
    })
    .setClassToggle(target, "is-animated")
    .addTo(controller);
  });



};



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js